// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","icon":"Header_icon__a8FkJ","text":"Header_text__Ib48F"};